import prettyBytes from "pretty-bytes";

const EM_DASH = "—";

const toFiniteNumber = (value: unknown): number | undefined => {
    if (value === undefined || value === null || value === "") {
        return undefined;
    }
    const n = typeof value === "number" ? value : Number(value);
    return Number.isFinite(n) ? n : undefined;
};

/**
 * Human-readable binary file size (KiB / MiB / GiB, base-1024) for display on the
 * FILE record screen. Empty / non-numeric input renders an em-dash.
 * (operator-task-fe-file-screen-humanreadable-size-and-content-type)
 */
export const formatFileSize = (bytes: unknown): string => {
    const n = toFiniteNumber(bytes);
    return n === undefined ? EM_DASH : prettyBytes(n, { binary: true });
};

/**
 * Exact byte count for the size field's hover tooltip, e.g. "1,048,576 bytes".
 * Returns undefined when there is no numeric size (Input then shows no tooltip).
 */
export const formatFileSizeExact = (bytes: unknown): string | undefined => {
    const n = toFiniteNumber(bytes);
    return n === undefined ? undefined : `${n.toLocaleString()} bytes`;
};

/**
 * Server-detected content-type for display. Empty / undetected (e.g. legacy files
 * written before content_type existed) renders an em-dash rather than "null".
 */
export const formatContentType = (contentType: unknown): string => {
    const s = typeof contentType === "string" ? contentType.trim() : "";
    return s === "" ? EM_DASH : s;
};

/**
 * Server-detected text encoding for display (e.g. "utf-8", "windows-1252",
 * "utf-16"). Empty renders an em-dash — this is the expected value for binary
 * files, undetectable content, and legacy files written before the column
 * existed (encoding detection runs for text content-types only).
 * (operator-task-file-content-encoding-detection)
 */
export const formatContentEncoding = (contentEncoding: unknown): string => {
    const s = typeof contentEncoding === "string" ? contentEncoding.trim() : "";
    return s === "" ? EM_DASH : s;
};
